import {Route, buildRoute} from '@synako/enhanced-router';
import {useCallback} from 'react';
import {UNIFIED_ROUTING_PATTERN, getModeFromUrl} from '@/utils/appMode';
import {matchPath} from 'react-router-dom';

/**
 * Remplaçant de useIsAssistanceMode / buildAssistanceRoute.
 *
 * Construit des URLs adaptées au contexte de routing :
 * - Routing unifié (/ffconnect/c/:client_id) : remplace /ffconnect par /ffconnect/c/:client_id
 * - Mode client normal : garde le chemin d'origine
 *
 * Propage automatiquement ?assistance=1 si présent dans l'URL courante.
 *
 * Utilise matchPath sur window.location plutôt que useParams,
 * car ce hook peut être appelé hors du Router (ex: toasts Chakra rendus dans un Portal).
 */
export const useClientRoute = () => {
  const mode = getModeFromUrl();
  const client_id = matchPath(UNIFIED_ROUTING_PATTERN, window.location.pathname)
    ?.params.client_id;
  const isAssistance = mode === 'assistance';

  const buildClientRoute = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (route: Route<any>, routeParams = {}, query = {}) => {
      // Propager ?assistance=1 dans les URLs générées
      const finalQuery = isAssistance ? {assistance: '1', ...query} : query;

      if (client_id) {
        // Routing unifié /ffconnect/c/:client_id
        const unifiedPath = route.path.replace(
          '/ffconnect',
          `/ffconnect/c/${client_id}`,
        );
        return buildRoute(
          {...route, path: unifiedPath},
          routeParams,
          finalQuery,
        );
      }
      return buildRoute(route, routeParams, finalQuery);
    },
    [client_id, isAssistance],
  );

  return {
    buildClientRoute,
  };
};
